// Qué mide cada fila. La unidad sola no alcanza ("%" puede ser humedad del
// aire o de suelo) y las sondas de suelo se distinguen por canal.
export type SensorMetric = 'temperature' | 'relative_humidity' | 'pressure' | 'rain' | 'wind_speed' | 'wind_direction' | 'soil_moisture';

// Sin id propio: la identifican estación, métrica, canal y momento.
export interface Measurement {
  deviceId: string;
  deviceName?: string;
  metric: SensorMetric;
  channel: number;
  value: number;
  unit: '%' | '°C' | 'hPa' | 'mm' | 'km/h' | '°';
  recordedAt: string;
}

export const METRIC_LABEL: Record<SensorMetric, string> = {
  temperature: 'Temperatura',
  relative_humidity: 'Humedad relativa',
  pressure: 'Presión',
  rain: 'Lluvia',
  wind_speed: 'Viento',
  wind_direction: 'Dirección del viento',
  soil_moisture: 'Humedad de suelo',
};
